import { helper } from '@ember/component/helper';
import { htmlSafe } from '@ember/template';

const safeStyle = function (params: [string | undefined], hash: { property: string }) {
	const property = hash.property;
	let string = '';
	if (property && typeof params?.[0] !== 'undefined') {
		string = `${property}: ${params[0]};`;
	}
	return htmlSafe(string);
};

const safeStyleHelper = helper(safeStyle);

export default safeStyleHelper;
